var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sprite',{class:("chevron-icon chevron-icon--" + _vm.color + " chevron-icon--" + _vm.size + " chevron-icon--" + _vm.direction),attrs:{"id":"app/arrow"}})}
var staticRenderFns = []

export { render, staticRenderFns }